import * as React from "react";
import { Stack } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import moment from "moment";
import "../../../Style/pageStyle.scss";

export default function SelectDatePicker({ format, views, date, setDate,inputFormat }) {
  return (
    <Stack className="page-container">
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          format={format ? format : "dd-MM-yyyy"}
          inputFormat={inputFormat ? inputFormat : "dd-MM-yyyy"}
          views={views}
          onChange={setDate}
          className="search-field"
          value={Boolean(date) ? new Date(date) : null}
        />
      </LocalizationProvider>
    </Stack>
  );
}
